<template>
    <div class="container">
        <div class="rich-text is-padded hyphenate">
            <div v-if="header"
                 :class="headerStyle"
                 class="title is-3">{{ header }}
            </div>
            <div v-if="subheader"
                 class="title is-4"
                 :class="headerStyle">{{ subheader }}
            </div>
            <div v-html="text"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RichText",
        props: {
            contentData: {
                type: Object,
                required: true
            }
        },
        computed: {
            text() {
                if (this.contentData.content.bodytext) {
                    return this.contentData.content.bodytext.replace(/(?:\r\n|\r|\n)/g, '<br>');
                }

                return "";
            },
            header() {
                return this.contentData.content.header;
            },
            subheader() {
                return this.contentData.content.subheader;
            },
            headerStyle() {
                let position;
                let color;

                switch (this.contentData.content.headerPosition) {
                    case "right":
                        position = "has-text-right";
                        break;
                    case "center":
                        position = "has-text-centered";
                        break;
                    default:
                        position = "has-text-left";
                }

                switch (this.contentData.content.headerLayout) {
                    case 0:
                        color = "has-text-grey";
                        break;
                    case 1:
                        color = "has-text-grey-dark";
                        break;
                    case 2:
                        color = "has-text-primary-dark";
                }
                return [color, position];
            }
        }
    }
</script>

<style lang="scss">
    .cms-view__content {
        .cms-view__element {
            .hero-banner {
                @media screen and (max-width: $desktop) {
                    h1, h2, h3, h4, h5, h6 {
                        font-size: inherit;
                    }
                }
            }
        }

        .rich-text {

            &.hyphenate, .hyphenate {
                word-break: keep-all;
                hyphens: manual;
                -ms-hyphens: manual;
                -moz-hyphens: manual;
                -webkit-hyphens: manual;
            }

            &.is-padded {
                padding: 0 1rem;
            }

            p:last-child, ul, ol {
                padding-bottom: 3rem;
            }

            h1, h2, h3, h4, h5, h6 {
                @extend .title
            }

            h1 {
                font-size: $size-2;
            }

            h2 {
                font-size: $size-3;
            }

            h3 {
                font-size: $size-4;
            }

            h4 {
                font-size: $size-5;
            }

            h5 {
                font-size: $size-6;
            }

            h6 {
                font-size: $size-6;
            }

            p {
                font-size: $size-6;
            }

            a {
                color: $primary-dark;

                &:hover {
                    color: $primary;
                }
            }

            ol, ul {
                padding-left: 1rem;
            }

            strong {
                font-family: GeomanistMedium, Helvetica, Arial, sans-serif;
                font-weight: normal;
                color: inherit;
            }

            .title {
                margin-bottom: 0;
            }

            .title.is-3 {
                font-family: GeomanistNormal, Helvetica, Arial, sans-serif;
                margin-bottom: 1.5rem;
            }

            .title.is-4 {
                font-family: GeomanistNormal, Helvetica, Arial, sans-serif;
                margin-bottom: 0.75rem;
            }

            .text-center {
                text-align: center;
            }

            .text-right {
                text-align: right;
            }

            .text-justify {
                text-align: justify;
            }
        }
    }

    @media screen and (min-width: $tablet) {
        .cms-view {
            .rich-text {
                &.is-padded {
                    padding: 0 1.5rem;
                }

                h1 {
                    font-size: $size-1;
                }

                h2 {
                    font-size: $size-2;
                }

                h3 {
                    font-size: $size-3;
                }

                h4 {
                    font-size: $size-4;
                }

                h5 {
                    font-size: $size-5;
                }

                h6 {
                    font-size: $size-6;
                }

                p {
                    font-size: $size-6;
                }

            }
        }
    }

</style>